import { Shadows, createTheme } from "@mui/material/styles";

export const theme = createTheme({
  direction: "rtl",
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"IRANYekanX", "Arial", sans-serif !important',
          lineHeight: 1.4,
          fontSize: 12,
        },
      },
    },
  },
  shadows: Array(25).fill("none") as Shadows,
  typography: {
    fontSize: 12,
    fontFamily: '"IRANYekanX", "Arial", sans-serif !important',
  },
  palette: {
    // SAMA brand — Yoozmeters × KAN catalog.
    // Kept in sync with `theme.extend.colors` in tailwind.config.js.
    primary: {
      main: "#14304D", // primary-80 — catalog header navy
      light: "#456181", // primary-60
      dark: "#0F2A45", // primary-90 — catalog deep navy
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F58220", // secondary-70 — Yoozmeters orange
      light: "#F8963F", // secondary-60
      dark: "#DB6F16", // secondary-80
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#DA3B3B",
      light: "#E45959",
      dark: "#BC3232",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#F5A100",
      light: "#FFB026",
      dark: "#D28A00",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#1F6BB0",
      light: "#4181BC",
      dark: "#1B5C97",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#12A366",
      light: "#2FB27A",
      dark: "#0F8B57",
      contrastText: "#FFFFFF",
    },
    grey: {
      50: "#F8FAFB",
      100: "#F4F6F8",
      200: "#E2E7EC",
      300: "#CDD4DC",
      400: "#9BA6B3",
      500: "#7A8695",
      600: "#5A6675",
      700: "#414951",
      800: "#2C333A",
      900: "#1C2126",
    },
    background: {
      default: "#F4F6F8", // catalog page canvas
      paper: "#FFFFFF",
    },
  },
});
